import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import LinearProgress from '@material-ui/core/LinearProgress'
import { setUrlRedirect } from '../../store/app/actions'
import { getCurrentAppData } from '../../utils/fractalApps'
import { getParamsFromQueryString } from '../../utils/url'
import LogoImage from '../image/LogoImage'
import RegisterBG from '../../assets/img/registro.png'
import LoginBG from '../../assets/img/login.png'
import ForgotPasswordBG from '../../assets/img/recuperarsenha.png'
import OrganizationsListFooter from '../footer/OrganizationsListFooter'
import LanguageSelector from '../shared/Language'
import Card from '../card/Card'

import {
  container,
  childContainer,
  bg
} from './styles/PublicTemplate.style'

const hasOrganizationIds = ['32']
class PublicTemplate extends Component {
  state = {
    open: false
  }
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.array,
      PropTypes.func
    ]).isRequired,
    setUrlRedirect: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    location: PropTypes.object,
    lang: PropTypes.string
  }

  static defaultProps = {
    loginValues: undefined
  }

  componentDidMount () {
    const { url_redirect: urlRedirect } = getParamsFromQueryString()

    if (urlRedirect) this.props.setUrlRedirect(urlRedirect)
  }

  render () {
    const { location: { pathname } } = this.props
    const templateBG = pathname === '/signup' ? RegisterBG
      : (pathname === '/login' || pathname === '/') ? LoginBG
        : pathname === '/forgot-my-password' ? ForgotPasswordBG : LoginBG
    const primaryColor = (getCurrentAppData() && getCurrentAppData().theme) ? getCurrentAppData().theme.primaryColor : '#878787'
    return (
      <div className={container}>
        <LanguageSelector lang={this.props.lang} />
        <div
          className={bg}
        >
          <img
            src={templateBG}
            alt='background'
            style={{ height: '50%', width: '50%', objectFit: 'contain' }}
          />
        </div>
        <div style={{
          flexGrow: '1',
          backgroundColor: primaryColor,
          height: '100vh'
        }}
        />
        <div className={childContainer}>
          <Card>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {this.props.isLoading && (
                <LinearProgress
                  color='#E1003A'
                  style={{ position: 'absolute', top: 0, left: 0 }}
                />
              )}
              {getCurrentAppData() ? (
                <>
                  <div
                    style={{
                      width: '100%',
                      maxWidth: 200,
                      alignSelf: 'center',
                      textAlign: 'center',
                      marginBottom: 16
                    }}
                  >
                    <img
                      style={{ width: '100%', height: 'auto' }}
                      src={getCurrentAppData().logo}
                      alt={getCurrentAppData().name}
                    />
                  </div>
                  {this.props.children}
                  <div
                    style={{
                      alignSelf: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '24px',
                      width: '12em'
                    }}>
                    <LogoImage horizontal responsive />
                  </div>
                </>
              ) : (
                <>
                  <LogoImage horizontal />
                  {this.props.children}
                </>
              )}
            </div>
            { getParamsFromQueryString() && hasOrganizationIds.includes(getParamsFromQueryString().app_id) &&
              <OrganizationsListFooter appId={getParamsFromQueryString().app_id} />
            }
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.auth.isFetching || state.passwordRecovery.isSubmitting,
  lang: state.auth.lang
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      setUrlRedirect
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToPros)(PublicTemplate))
